/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompiledReportRow } from './compiledReportRow';


export interface CompiledReport {
    playerAge?: number;
    playerHeight?: number;
    playerImageAddress?: string;
    playerName?: string;
    playerWeight?: number;
    referenceAge?: number;
    referenceHeight?: number;
    referenceName?: string;
    referenceWeight?: number;
    reportDateTime?: string;
    rows?: Array<CompiledReportRow>;
    title?: string;
}

